function normalizeText(value, fallback = "") {
  if (value === undefined || value === null) return fallback;
  const normalized = String(value).replace(/\s+/g, " ").trim();
  return normalized || fallback;
}

const BIO_PHRASE_PATTERN =
  /\b(has spent|spent the past|career focused|focus(?:ed|es)? on|works? with|collaborat(?:e|es|ion)|develop(?:s|ed)?|execut(?:es|ed)|driv(?:es|en)|responsible for|passionate about|bringing|building|helping|leading strategy|through collaboration)\b/i;

function normalizeContactKind(value, fallback = "") {
  const normalized = normalizeText(value, "")
    .replace(/\s+/g, "_")
    .toLowerCase();

  if (normalized.includes("recruiter")) return "recruiter";
  if (
    normalized === "contact" ||
    normalized.includes("team_member") ||
    (normalized.includes("contact") && !normalized.includes("hiring_manager"))
  ) {
    return "contact";
  }
  if (normalized.includes("hiring_manager")) return "hiring_manager";

  if (fallback && fallback !== value) {
    return normalizeContactKind(fallback, "");
  }

  return "";
}

export function looksLikeContactBio(value = "") {
  const raw = String(value ?? "");
  const normalized = normalizeText(raw);
  if (!normalized) return false;

  const wordCount = normalized.split(/\s+/).filter(Boolean).length;

  if (normalized.length >= 160) return true;
  if (wordCount >= 22) return true;
  if (wordCount >= 10 && /[.!?]/.test(raw)) return true;
  if (wordCount >= 12 && /\r|\n/.test(raw)) return true;
  if (wordCount >= 12 && BIO_PHRASE_PATTERN.test(normalized)) return true;

  return false;
}

export function getDefaultContactRoleLabel({
  contactKind = "",
  source = "",
  fallback = "Hiring Manager",
} = {}) {
  const normalizedKind = normalizeContactKind(contactKind, "");
  if (normalizedKind === "recruiter") return "Recruiter";
  if (normalizedKind === "contact") return "Team Member";

  if (normalizeText(source).toLowerCase() === "ai team scan") {
    return "Team Member";
  }

  return normalizeText(fallback, "Hiring Manager");
}

export function normalizeContactRoleLabel(value, options = {}) {
  const fallback = getDefaultContactRoleLabel(options);
  const normalized = normalizeText(value);
  if (!normalized) return fallback;
  if (looksLikeContactBio(value)) return fallback;
  return normalized;
}
